import api from './../../api';
import { push } from 'connected-react-router';
import { store as storeNotification } from 'react-notifications-component';
import { socket } from './../store/socket';

const notificationConfig = {
  container: 'top-center',
  animationIn: ['animated', 'fadeIn'],
  animationOut: ['animated', 'fadeOut'],
  dismiss: {
    duration: 1500,
    showIcon: true
  }
};

export const usersStartRequest = () => {
  return {
    type: 'USERS_START_REQUEST'
  };
};

export const usersEndRequest = () => {
  return {
    type: 'USERS_END_REQUEST'
  };
};

export const getAllUsersSuccess = ({ data }) => {
  return {
    type: 'USERS_GET_ALL_SUCCESS',
    payload: data
  };
};

export const getAllUsersError = error => {
  return {
    type: 'USERS_GET_ALL_ERROR',
    payload: error
  };
};

export const addUsersSuccess = ({ data }) => {
  return {
    type: 'USERS_ADD_SUCCESS',
    payload: data
  };
};

export const addUsersError = error => {
  return {
    type: 'USERS_ADD_ERROR',
    payload: error
  };
};

export const editUsersSuccess = ({ data }) => {
  return {
    type: 'USERS_EDIT_SUCCESS',
    payload: data
  };
};

export const editUsersError = error => {
  return {
    type: 'USERS_EDIT_ERROR',
    payload: error
  };
};

export const removeUsersSuccess = id => {
  return {
    type: 'USERS_REMOVE_SUCCESS',
    payload: id
  };
};

export const removeUsersError = error => {
  return {
    type: 'USERS_REMOVE_ERROR',
    payload: error
  };
};

export const usersModifyStore = ({ data }) => {
  return {
    type: 'USERS_MODIFY_STORE',
    payload: data
  };
};

export const addUsers = (data, formReset, submitBtn) => {
  return async dispatch => {
    try {
      submitBtn.disabled = true;
      dispatch(usersStartRequest());
      const response = await api().post('/api/users', data);
      dispatch(addUsersSuccess(response));
      socket.emit('requestChangeStore', {
        token: localStorage.getItem('token') || '',
        type: 'ADD',
        module: 'users',
        data: [response.data]
      });
      formReset();
    } catch (err) {
      dispatch(addUsersError(err));
    } finally {
      document
        .getElementsByClassName('page-content')[0]
        .scrollTo({ top: 0, left: 0, behavior: 'smooth' });
      setTimeout(() => {
        dispatch(usersEndRequest());
        submitBtn.disabled = false;
      }, 1800);
    }
  };
};

export const getAllUsers = (params = {}) => {
  return async dispatch => {
    try {
      dispatch(usersStartRequest());
      const response = await api().get('/api/users', { params });
      dispatch(getAllUsersSuccess(response));
    } catch (err) {
      dispatch(getAllUsersError(err));
    } finally {
      dispatch(usersEndRequest());
    }
  };
};

export const editUsers = (data, submitBtn = {}, handleModalClose) => {
  return async dispatch => {
    const defaultMsg = button => {
      return new Promise(resolve => {
        document
          .getElementsByClassName('page-content')[0]
          .scrollTo({ top: 0, left: 0, behavior: 'smooth' });
        setTimeout(() => {
          dispatch(usersEndRequest());
          button.disabled = false;
          resolve(true);
        }, 1800);
      });
    };

    try {
      submitBtn.disabled = true;
      dispatch(usersStartRequest());
      const id = data._id;
      const response = await api().put('/api/users/' + id, data);
      dispatch(editUsersSuccess(response));
      socket.emit('requestChangeStore', {
        token: localStorage.getItem('token') || '',
        type: 'EDIT',
        module: 'users',
        data: [response.data]
      });
      await defaultMsg(submitBtn);
      if (handleModalClose) {
        handleModalClose();
      } else {
        dispatch(push('/users'));
      }
    } catch (err) {
      dispatch(editUsersError(err));
      await defaultMsg(submitBtn);
    }
  };
};

export const removeUsers = id => {
  return async dispatch => {
    try {
      dispatch(usersStartRequest());
      await api().delete('/api/users/' + id);
      dispatch(removeUsersSuccess(id));
      socket.emit('requestChangeStore', {
        token: localStorage.getItem('token') || '',
        type: 'REMOVE',
        module: 'users',
        data: id
      });
      setTimeout(() => {
        storeNotification.addNotification({
          ...notificationConfig,
          message: 'Usuário removido com sucesso.',
          type: 'success'
        });
      }, 300);
    } catch (err) {
      dispatch(removeUsersError(err));
      setTimeout(() => {
        storeNotification.addNotification({
          ...notificationConfig,
          message: 'Falha ao remover usuário.',
          type: 'danger'
        });
      }, 300);
    } finally {
      document
        .getElementsByClassName('page-content')[0]
        .scrollTo({ top: 0, left: 0, behavior: 'smooth' });
      dispatch(usersEndRequest());
    }
  };
};

export const restoreUsers = data => {
  return async dispatch => {
    try {
      dispatch(usersStartRequest());
      const id = data._id;
      const response = await api().put('/api/users/' + id, data);
      dispatch(editUsersSuccess(response));
      socket.emit('requestChangeStore', {
        token: localStorage.getItem('token') || '',
        type: 'RESTORE',
        module: 'users',
        data: [response.data]
      });
      setTimeout(() => {
        storeNotification.addNotification({
          ...notificationConfig,
          message: 'Usuário restaurado com sucesso.',
          type: 'success'
        });
      }, 300);
    } catch (err) {
      dispatch(editUsersError(err));
      setTimeout(() => {
        storeNotification.addNotification({
          ...notificationConfig,
          message: 'Falha ao restaurar usuário.',
          type: 'danger'
        });
      }, 300);
    } finally {
      document
        .getElementsByClassName('page-content')[0]
        .scrollTo({ top: 0, left: 0, behavior: 'smooth' });
      dispatch(usersEndRequest());
    }
  };
};

export const logoutUsers = data => {
  return async dispatch => {
    try {
      dispatch(usersStartRequest());
      const id = data._id;
      const extensions = (await api().get(
        `/api/devices/linked_user?user=${id}`
      )).data;
      extensions.forEach(async ext => {
        const obj = { extension: ext.number, idExtension: ext._id };
        await api().post('/api/devices/logout_extension', obj);
      });
      const response = await api().post('/api/auth/logout', { userId: id });
      dispatch(editUsersSuccess(response));
      socket.emit('requestChangeStore', {
        token: localStorage.getItem('token') || '',
        type: 'EDIT',
        module: 'users',
        data: [response.data]
      });
      setTimeout(() => {
        storeNotification.addNotification({
          ...notificationConfig,
          message: 'Usuário deslogado do sistema com sucesso.',
          type: 'success'
        });
      }, 300);
    } catch (err) {
      dispatch(editUsersError(err));
      setTimeout(() => {
        storeNotification.addNotification({
          ...notificationConfig,
          message: 'Falha ao deslogar usuário do sistema.',
          type: 'danger'
        });
      }, 300);
    } finally {
      document
        .getElementsByClassName('page-content')[0]
        .scrollTo({ top: 0, left: 0, behavior: 'smooth' });
      dispatch(usersEndRequest());
    }
  };
};
